import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FexidocLogo } from "@/components/FexidocLogo";
import { useAuth } from "@/lib/auth";
import { VerifyEmailActions } from "@/components/VerifyEmailCard";
import { MailCheck, LogOut } from "lucide-react";

export default function VerifyPending() {
  const { user, workspaces, logout } = useAuth();
  const nav = useNavigate();

  const done = () => nav(workspaces.length ? "/app" : "/onboarding", { replace: true });

  useEffect(() => {
    if (user?.email_verified) done();
    // eslint-disable-next-line
  }, [user?.email_verified]);

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10" data-testid="verify-pending-page">
      <div className="w-full max-w-xl">
        <div className="text-center mb-8"><FexidocLogo size={32} /></div>
        <div className="fx-panel p-8">
          <div className="w-11 h-11 rounded-xl bg-cyan-500/10 border border-cyan-400/30 flex items-center justify-center">
            <MailCheck size={20} className="text-cyan-300" />
          </div>
          <h1 className="font-display text-2xl font-bold text-white mt-5">Verify your email</h1>
          <p className="text-sm text-slate-400 mt-2">We sent a verification link to:</p>
          <div className="mt-1 text-base text-cyan-200 mono break-all" data-testid="verify-pending-email">{user?.email}</div>
          <p className="text-sm text-slate-400 mt-4 leading-relaxed">
            Verify your email to finish setting up your Fexidoc workspace. Templates, documents,
            team invites and billing stay locked until this is done.
          </p>
          <div className="mt-6"><VerifyEmailActions onVerified={done} /></div>
          <div className="mt-8 pt-5 border-t border-[#1E293B] flex items-center justify-between text-xs text-slate-500">
            <span>Can't find it? Check your spam or junk folder.</span>
            <button onClick={() => { logout(); nav("/login"); }} className="inline-flex items-center gap-1 hover:text-slate-300" data-testid="verify-pending-signout"><LogOut size={12} /> Sign out</button>
          </div>
        </div>
      </div>
    </div>
  );
}
